module.exports = __webpack_public_path__ + "static/data_api_icon-89391741aed9e59b075f276338e0aeda.svg";